
import { monitorGlobalEvents, ready, setupNewSession, switchLanguage } from '@/modules/app/app'
import Market from '@/modules/market/Market.index.vue'
import Symbol from '@/modules/market/Symbol.vue'
import Account from '@/views/Account.vue'
import Header from '@/views/Header.vue'
import TransitionProvider from '@/provider/TransitionProvider.vue'
import Popup from 'common/popout/Popup.vue'
import { computed, onMounted } from 'vue'
import { dynamicAliveList } from '@/features/dynamicAlive'
import { useRouter } from 'vue-router'

export default {
  components: { Account, Header, TransitionProvider, Symbol, Market, Popup },
  setup () {
    const router = useRouter()

    setupNewSession()

    monitorGlobalEvents()

    onMounted(() => {
      // 重置所有dialog产生的hashQuery
      // router.replace('/')

      switchLanguage().then(() => {
        ready(router)
      })
    })

    return {
      cacheList: computed(() => ['TabPage', 'CopyTrade', ...dynamicAliveList.value]),
    }
  },
}
